import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4fa404c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a4fa404c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fa404c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4fa404c')) {
      api.createRecord('a4fa404c', component.options)
    } else {
      api.reload('a4fa404c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a4fa404c&scoped=true", function () {
      api.rerender('a4fa404c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/correctionRecord/index.vue"
export default component.exports